import React from 'react';
import classNames from 'classnames';
import * as mobxReact from 'mobx-react';
import { useIntl } from 'react-intl';
import { FormField } from '../../../../../global/form/form-field/form-field';
import { DefaultDatePicker } from '../../../../../global/default-datepicker/default-datepicker';
import { MeetingFormDataVM } from '../meeting-form-data.viewmodel';
import { TimeInput } from '../../../../../global/time-input/time-input';
import { DATE_TEXT, END_TIME_TEXT, START_TIME_TEXT } from '../../../../../../constants/common-labels.constants';
interface IProps {
    formData: MeetingFormDataVM;
    index: number;
    eventTimezone: string;
    meetingDate: Date;
    startDate: Date;
    endDate: Date;
    dateTimeListLength: number;
    highlightDates?: Date[];
    defaultMeetingDuration?: number;
    dateformat: string;
}

export const DateTimeFormView = mobxReact.observer((props: IProps) => {
    const {
        formData,
        index,
        eventTimezone,
        meetingDate,
        startDate,
        endDate,
        dateTimeListLength,
        highlightDates,
        defaultMeetingDuration,
        dateformat
    } = props;
    const intl = useIntl();
    const timeValidationErrorForList = formData.getTimeValidationErrorCreate(index);

    return (
        <>
            <div className='flex' >
                <FormField
                    label={index === 0 ? intl.formatMessage(DATE_TEXT) : ''}
                    className='oe-form-field__create-date'
                >
                    <DefaultDatePicker
                        className='oe-form-field__control'
                        id={`meetingDate-${index}`}
                        dateformat={dateformat}
                        showTimeSelect={false}
                        selected={meetingDate}
                        timeZone={eventTimezone}
                        onChange={date => formData.setNewValueInDateTimeList(index, 'meetingDate', date, eventTimezone)}
                        highlightDates={highlightDates}
                    />
                </FormField>
                <FormField
                    label={index === 0
                        ? intl.formatMessage(START_TIME_TEXT)
                        : ''}
                    className='oe-form-field__create-start'
                >
                    <TimeInput
                        className='oe-form-field__control'
                        date={startDate}
                        disabled={!meetingDate}
                        onChange={date => formData.setNewValueInDateTimeList(index, 'startDate', date, eventTimezone, defaultMeetingDuration)}
                        timeZone={eventTimezone}
                        onError={() => formData.setStartTimeValidationErrorCreate(true, index)}
                    />
                </FormField>
                <FormField
                    label={index === 0
                        ? intl.formatMessage(END_TIME_TEXT)
                        : ''}
                    className='oe-form-field__create-end'
                >
                    <TimeInput
                        className='oe-form-field__control'
                        date={endDate}
                        disabled={!meetingDate}
                        onChange={date => formData.setNewValueInDateTimeList(index, 'endDate', date, eventTimezone)}
                        timeZone={eventTimezone}
                        onError={() => formData.setEndTimeValidationErrorCreate(true, index)}
                    />
                </FormField>
                <div className='flex center m-bottom-5px'>
                    <span
                        className={classNames(
                            `material-icons text-red text-hover-red ${index === 0 && 'p-top-20px'} p-left-6px font-size-18px cursor-point`,
                            { 'disabled': (index === 0 && dateTimeListLength === 1) }
                        )}
                        onClick={() => formData.removeValueFromDateTimeList(index)}
                    >
                        close
                    </span>
                </div>
            </div>
            <>
                {formData.getMeetingDateErrorCreate(index)
                    && <div className='oe-form-field__error m-top-0px'>
                            {formData.getMeetingDateErrorCreate(index)}
                        </div>
                }
                <div className='oe-form-field__error m-bottom-5px'>
                    {timeValidationErrorForList
                        ? timeValidationErrorForList
                        : formData.getMeetingTimesErrorCreate(index)
                    }
                </div>
            </>

        </>
    );
});
